/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { addslashes, array_unique, htmlspecialchars, mj_make_filename, str_trim } from './util.js';
import { mj } from './page-mj.js';
import { mjt } from './i18ntexts.js';

import { MPlugins } from './plugins.js';

import { MDMeta } from './meta-data.js';
import { MVMediaMetadata } from './media-data-view.js';

/**
 * add backlinks & "show all" link to "ref_media" meta data fields
 */
export function register_ref_media_meta_field_plugin( $, meta_id ) {

	var plugin_name = 'std-view-ref-media-'+meta_id;
	if( !MPlugins.isRegistered(plugin_name) ) {
		MPlugins.register( [], plugin_name, {
			type: 'MediaMetaViewData',
			meta_ids: [ meta_id ],
			setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo ) {
				var lnks_outbound = [],
					lnks_inbound = [],
					lnks_all = [],
					lnks_transitive = [],
					td = tr.children('td'),
					dh = td.children('.data-holder').empty();
				val_html = '';
				if( val_arr && val_arr.length ) {
					for( var i=0; i<val_arr.length; ++i ) {
						var val = val_arr[i];
						lnks_outbound.push(val);
						lnks_all.push(val);
						if( i>0 ) val_html += '<br />';
						val_html += '<span class="link" onclick="MVMediaPage.start_search(\''+htmlspecialchars(addslashes(val),true,true)+'\',3)"'
									+' title="'+(mjt('link-to-info').replace('%1',val).replace('%2',media_id))+'">'
										+(mjt('link-to').replace('%1',val))
									+'</span>'
									+' | '
									+'<span class="link" onclick="MVMediaPage.start_search(\''+htmlspecialchars(addslashes(val),true,true)+'\','+meta_id+')"'
									+' title="'+(mjt('all-links-to-info').replace('%1',val).replace('%2',media_id))+'">'
										+(mjt('all-links-to').replace('%1',val))
									+'</span>';
					}
				}
				if( dh.length ) dh.html(val_html);
				else td.html(dh=MVMediaMetadata.wrapWithMetaDataHolder(meta_id,val_html));
				lnks_outbound = array_unique(lnks_outbound);
				if( lnks_outbound.length > 0 ) dh.append('<br /><span class="emph-link different" onclick="MVMediaPage.start_search('+htmlspecialchars(JSON.stringify(lnks_outbound),true,true)+',3)" title="'+lnks_outbound.join(', ')+'">'+mjt('links-show-all-outbound')+' ('+lnks_outbound.length+')</span>');
				var postdata = 'media_id='+encodeURIComponent(media_id)
							+ '&meta_id='+meta_id
							+ '&outbound_links='+encodeURIComponent(lnks_outbound.join(','));
				$.postJSON('json/media/meta-transitivelinks', postdata, function(j) {
					if( j && !j.error ) {
						if( j.inbound && j.inbound.length ) {
							// inbound links
							var lnks = [],
								jil = j.inbound.length;
							for( var i=0; i<jil; ++i ) {
								var val = j.inbound[i],
									inbound_display_data_item = '<span class="link" onclick="MVMediaPage.start_search(\''+htmlspecialchars(addslashes(val),true,true)+'\',3)"'
																+' title="'+(mjt('links-to-info').replace('%1',val).replace('%2',media_id))+'">'
																	+(mjt('links-to').replace('%1',val))
																+'</span>';
								lnks.push( inbound_display_data_item );
								lnks_inbound.push(val);
								lnks_all.push(val);
							}
							dh.append('<span class="xinfo">'+(dh.children('span').length?'<br />':'')+lnks.join('<br />')+'</span>');
						}
						if( j.transitive && j.transitive.length ) lnks_transitive = j.transitive; // transitive links
					}
					tr.removeClass('md-hide').addClass('md-avl');
					if( lnks_inbound.length > 0 ) dh.append('<br /><span class="emph-link different" onclick="MVMediaPage.start_search('+htmlspecialchars(JSON.stringify(lnks_inbound),true,true)+',3)" title="'+lnks_inbound.join(', ')+'">'+mjt('links-show-all-inbound')+' ('+lnks_inbound.length+')</span>');
					lnks_all = array_unique(lnks_all);
					if( lnks_all.length > 0 && ( lnks_outbound.length>0 && lnks_inbound.length>0 ) ) dh.append('<br /><span class="emph-link different" onclick="MVMediaPage.start_search('+htmlspecialchars(JSON.stringify(lnks_all),true,true)+',3)" title="'+lnks_all.join(', ')+'">'+mjt('links-show-all-all')+' ('+lnks_all.length+')</span>');
					if( lnks_transitive.length > 1 ) dh.append('<br /><span class="emph-link different" onclick="MVMediaPage.start_search('+htmlspecialchars(JSON.stringify(lnks_transitive),true,true)+',3)" title="'+lnks_transitive.join(', ')+'">'+mjt('links-show-transitive')+' ('+lnks_transitive.length+')</span>');
				} );
			},
		} );
	}
}

export function register_std_plugins() {
	/**
	 * combine image width, height & type into one field
	 */
	MPlugins.register( [], 'std-view-img-dims-and-type', {
		type: 'MediaMetaViewData',
		meta_ids: [ 200, 201, 226 ],
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo ) {
			if( meta_id==201 ) {
				// NOTE: always change the label (important for diff view)
				tr.children('th').text(mjt('meta-def-image-width-height-type','!'));
				// display combined info in this field
				var m = dtinfo.meta,
					img_width = m[200] && m[200][0] ? m[200][0] : 0,
					img_height = m[201] && m[201][0] ? m[201][0] : 0;
				if( img_width>0 || img_height>0 ) {
					var img_type = m[226] && m[226][0] ? m[226][0] : 'RASTER';
					var img_dims_html = MVMediaMetadata.getInteractiveDisplayDataItem(media_id,img_width,200)+' x '+MVMediaMetadata.getInteractiveDisplayDataItem(media_id,img_height,201);
					if( img_type=='VECTOR' ) img_dims_html += ' (<span class="link" onclick="MVMediaPage.start_search(\'VECTOR\',226)">'+mjt('image-type-scalable')+'</span>)';
					tr.removeClass('md-hide').addClass('md-avl').children('td').html(MVMediaMetadata.wrapWithMetaDataHolder([200,201],img_dims_html));
				}
			} else {
				// hide the other fields
				tr.removeClass('md-avl').addClass('md-hide');
			}
		},
	} );

	/**
	 * combine different data for custom previews into one field
	 */
	MPlugins.register( [], 'std-view-custom-previews', {
		type: 'MediaMetaViewData',
		meta_ids: [ 10, 11, 12 ],
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo ) {
			if( meta_id==10 ) {
				// NOTE: always change the label (important for diff view)
				tr.children('th').text(mjt('meta-def-custom-preview','!'));
				// display combined info in this field
				var m = dtinfo.meta,
					cp_width = m[10] && m[10][0] ? m[10][0] : 0,
					cp_height = m[11] && m[11][0] ? m[11][0] : 0,
					cp_uploaded = m[12] && m[12][0] ? m[12][0] : '',
					cp_defined = cp_width>0,
					cp_info_html = cp_defined ? (MDMeta.getDisplayDataItem(cp_width,10)+' x '+MDMeta.getDisplayDataItem(cp_height,11)+' ('+MDMeta.getDisplayDataItem(cp_uploaded,12)+')') : mjt('custom-preview-none'),
					can_edit = mj.role_manager && dtinfo.r_edit;
				tr.removeClass('md-hide').addClass('md-avl').find('>td').html(MVMediaMetadata.wrapWithMetaDataHolder([10,11,12],cp_info_html));
				if( can_edit ) tr.attr('data-edit','1');
			} else {
				// hide the other fields
				tr.removeClass('md-avl').addClass('md-hide');
			}
		},
	} );

	/**
	 * show "photoshop-clip-path-index" as a highlighted item in list of clip path names (photoshop-path-names)
	 */
	MPlugins.register( [], 'std-view-photoshop-clip-path', {
		type: 'MediaMetaViewData',
		meta_ids: [ 233, 234 ],
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo ) {
			if( meta_id==233 ) {
				// NOTE: always change the label (important for diff view)
				tr.children('th').text(mjt('meta-def-photoshop-path-names-and-clip-path','!'));
				// display combined info in this field
				var m = dtinfo.meta;
				var img_clip_path_idx = m[234] && m[234][0] ? m[234][0] : -1;
				if( img_clip_path_idx>=0 ) {
					var data_elem = tr.find('>td>.data-holder>.data[data-listpos='+img_clip_path_idx+']');
					if( data_elem.length ) data_elem.addClass('emph').append(' <span class="link" onclick="MVMediaPage.start_search(\'?*\',234)">'+mjt('meta-def-photoshop-path-is-clip-path')+'</span>');
				} else {
					tr.find('>td>.data-holder').append('<br><span class="data other"><span class="link" onclick="MVMediaPage.start_search(\'\',234)">'+mjt('meta-def-photoshop-path-no-clip-path')+'</span></span>');
				}
			} else {
				// hide the other fields
				tr.removeClass('md-avl').addClass('md-hide');
			}
		},
	} );

	/**
	 * restore suffix on "filename" (1) when updating
	 */
	MPlugins.register( [], 'std-save-1', {
		type: 'MediaMetaSaveData',
		meta_ids: [ 1 ],
		beforeSaveMetaData: function( media_ids, meta_id, data, cur_data ) {
			if( data.meta && data.meta[1] && data.meta[1].length ) {
				var new_fn = data.meta[1][0],
					dot_pos = new_fn.lastIndexOf('.'),
					old_sfx = cur_data.meta && cur_data.meta[6] && cur_data.meta[6].length ? cur_data.meta[6][0] : null,
					new_sfx;
				if( old_sfx !== null ) {
					if( dot_pos==-1 ) {
						// filename suffix is missing ...
						// -> append the old suffix
						new_fn = new_fn + '.' + old_sfx;
					} else {
						// filename is OK
						// - compare suffix to old one ...
						new_sfx = new_fn.substr(dot_pos+1).toLowerCase();
						if( new_sfx != old_sfx.toLowerCase() ) {
							// filename suffix is DIFFERENT ...
							// if( false ) {
							// 	// -> append the old suffix (so it will have both old and new suffix appended)
							// 	new_fn = new_fn + '.' + old_sfx;
							// } else {
							// -> restore the old suffix
							new_fn = str_trim( new_fn.substr(0,dot_pos) ) + '.' + old_sfx;
							// }
						}
					}
				}
				// make safe filename
				new_fn = mj_make_filename(new_fn);
				// store
				data.meta[1][0] = new_fn;
			}
		},
	} );

	/**
	 * add a/v-related status info to thumbnail views
	 */
	MPlugins.register( [], 'std-av-thumb-view-1', function() {
		return {
			type: 'MediaThumbnailView',
			meta_ids: [ 802 ], // 802=avcontainer-duration
			bindStatusChanged: function( view_mode, cb ) {
			},
			queryMediaViewStatus: function( view_mode, media_ids, meta, trigger_status_change ) {
			},
			resetViewNode: function( view_mode, node, media_id ) {
				if( view_mode==='link' ) return; // ignored here
				node.removeClass('av-playable');
			},
			updateViewNode: function( view_mode, node, media_id, meta ) {
				// view_mode is one of: 'lightbox', 'result', 'mj-thumb-box', 'link'
				if( view_mode==='link' ) return; // ignored here
				var av_playable = !!(meta[802]&&meta[802][0]);
				if( av_playable ) {
					if( node.find('.media-overlay-1-av-playable').length===0 ) {
						var ovl_html = '<div class="media-overlay-1 media-overlay-1-av-playable keep"></div>';
						if( view_mode==='result' ) node.find('.thumbnail').append(ovl_html);
						else if( view_mode==='lightbox' ) node.prepend(ovl_html);
						else if( view_mode==='mj-thumb-box' ) node.append(ovl_html);
					}
					node.addClass('av-playable');
				} else {
					node.removeClass('av-playable');
				}
			},
			initViewNodesRoot: function( view_mode, root_node, on_action ) {
				//if( view_mode==='result' || view_mode==='lightbox' || view_mode==='mj-thumb-box' ) {
				//}
			},
		};
	} );

	/** dummy plugin
	MPlugins.register( [$,mj], 'std-view-dummy-hide-some-stuff', {
		type: 'MediaMetaViewData',
		meta_ids: [ 10,11,12,13,14,15,16,17,18,19,20,   233,234,   200,201,226, 101,114 ],
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo ) {
			// hide all rows
			tr.removeClass('md-avl').addClass('md-hide');
		}
	} );
	***/
}

